// extracted by mini-css-extract-plugin
export default {"users":"UserList_users__WWtRX","wrapperElement":"UserList_wrapperElement__o6euk","textGroup":"UserList_textGroup__m0Qrk"};